export const castformatdata = movieDataExists => {
  if (movieDataExists.cast_En) {
    const moviecastFromWIki = movieDataExists.cast_En.map(e => {
      if (e.name_En) {
        return {
          PK: e.PK,
          SK: e.SK,
          personID: e.personID,
          name_En: e.name_En,
          name_Te: e.name_Te,
          role: `${e.name_En ? e.name_En : ''} ${e.role ? e.role : ''}`,
          roleName_En: e.role ? e.role : '',
          weight: e.weight,
        }
      }

      return ''
    })
    return moviecastFromWIki.filter(e => e !== '')
  }

  return []
}

export const castformatdatate = movieDataExists => {
  if (movieDataExists.cast_En) {
    const moviecastFromWIkiTelugu = movieDataExists.cast_En.map(e => {
      if (e.name_En) {
        return `${e.name_Te ? e.name_Te : ''} `
      }

      return false
    })
    return moviecastFromWIkiTelugu.filter(e => e !== false)
  }

  return []
}
